<template>
    <v-circle
            :config="pointerConfig"
            @click="handleClick"
            @contextmenu="handleRightClick"
            @mouseover="hover(true)"
            @mouseout="hover(false)"
    ></v-circle>
</template>

<script>
    import { mapState, mapActions } from 'vuex';

    export default {
        name: "LineEndPointer",

        props: [
            'id',
            'x',
            'y',
            'lineColor',
            'lineColorHover',
            'fillColor',
        ],

        data() {
            return {
                isHovered: false,
            }
        },

        computed: {
            ...mapState('editor', [
                'USER_ACTIONS',
                'userAction',
            ]),

            borderColor() {
                return this.isHovered ? this.lineColorHover : this.lineColor;
            },

            pointerConfig() {
                return {
                    name: 'LineEndPointer',
                    id: this.id.toString(),
                    x: this.x,
                    y: this.y,
                    radius: 5,
                    stroke: this.borderColor,
                    strokeWidth: 3,
                    fill: this.fillColor,
                }
            },

        },

        methods: {
            ...mapActions('editor', [
                'addHem',
                'addFold',
            ]),

            ...mapActions('contextMenu', [
                'openContextMenu',
            ]),

            handleClick() {
                switch (this.userAction) {
                    case this.USER_ACTIONS.SET_OPEN_HEM:
                    case this.USER_ACTIONS.SET_CLOSE_HEM: {
                        this.addHem({pointId: this.id});
                        break;
                    }

                    case this.USER_ACTIONS.SET_FOLD: {
                        this.addFold({pointId: this.id});
                        break;
                    }

                    default:
                        break;
                }
            },

            handleRightClick(e) {
                e.evt.preventDefault();

                let position = {
                    x: this.x,
                    y: this.y,
                };

                this.openContextMenu({id: this.id, position});
            },

            hover(state) {
                this.isHovered = !!state;
            },

        },

    }
</script>

<style scoped>

</style>